// Pool quote identity. Pools quoted in something other than TON (USD₮,
// jetton/jetton) are admitted by WT_DISCOVER_NON_TON_POOLS: their pair page is
// read-only and every quote-amount label must name the real quote, not GRAM.
// TON-equivalent quotes (native TON + pTON masters, lib/tonQuote) keep the
// historical GRAM presentation.

import type { PairDetail } from '../api/types'
import { shortAddr, shouldDisplayTicker } from './format'
import { isTonQuoteToken } from './tonQuote'

export interface PairQuote {
  tonQuoted: boolean
  /** Display label of the quote leg: 'GRAM' for TON pools, else the quote
      ticker or a short address. */
  ticker: string
}

export const TON_PAIR_QUOTE: PairQuote = {
  tonQuoted: true,
  ticker: 'GRAM',
}

// Ticker only when it is a real symbol (shouldDisplayTicker rejects the
// backend's address-prefix fallback), else the short address.
function quoteTickerLabel(quoteToken: string, quoteTicker?: string): string {
  return shouldDisplayTicker(quoteTicker, quoteToken) ? quoteTicker : shortAddr(quoteToken)
}

export function pairQuoteOf(
  pair: Pick<PairDetail, 'quote_token' | 'quote_ticker'> | null | undefined
): PairQuote {
  const quoteToken = pair?.quote_token
  if (!quoteToken || isTonQuoteToken(quoteToken)) return TON_PAIR_QUOTE
  return { tonQuoted: false, ticker: quoteTickerLabel(quoteToken, pair?.quote_ticker) }
}

/** Row label for a non-TON quote on Discover/search rows; null for TON/empty. */
export function quoteLabel(quoteToken?: string, quoteTicker?: string): string | null {
  if (!quoteToken || isTonQuoteToken(quoteToken)) return null
  return quoteTickerLabel(quoteToken, quoteTicker)
}
